import { useRef, useEffect, useCallback } from 'react';
import { Box } from '@mui/material';
import ComponentNotifier from '../../../../services/wss/ComponentNotifier';
import { EngineNames } from '../../../../services/wss/events/EngineNames';
import iframeController from './IframeController';
import messageRouter from './MessageRouter';
import EntryGuard from './EntryGuard';

/**
 * Renderer for v2 intake form templates.
 * Responsible for refs, guards, and lifecycle only.
 * @param {object} entry
 * @param {string} viewMode
 */
export default function InputFormRenderer({ entry, viewMode }) {
    const iframeRef = useRef(null);

    const rebuild = useCallback(() => iframeController.rebuild(entry, iframeRef.current), [entry?.rk, entry?.tid]);

    useEffect(() => {
        messageRouter.register(iframeRef.current, entry, entry?.tid, rebuild);
        return () => messageRouter.unregister();
    }, [entry?.tid, rebuild]);

    useEffect(() => {
        rebuild();
    }, [entry?.rk, entry?.tid, viewMode]);

    // templatesChanged niet subscriben — templates zijn geladen bij bootup
    // widget saves via SignalR triggeren anders onnodige rebuilds
    // useEffect(() => {
    //     const onTemplatesChanged = (e) => {
    //         if (e.target !== 'templatesChanged') return;
    //         rebuild();
    //     };
    //     const unsub = ComponentNotifier.subscribe(EngineNames.TemplateEngine, onTemplatesChanged);
    //     return () => unsub();
    // }, [entry?.tid]);

    // Short-circuit render — viewMode override or entry validation failed
    const errorSnippet = EntryGuard.validate(entry, viewMode);
    if (errorSnippet) return errorSnippet;

    return (
        <Box id="input-form-renderer-root" sx={{ width: '100%', height: '100%' }}>
            <iframe
                ref={iframeRef}
                sandbox="allow-scripts"
                style={{ width: '100%', height: '100%', border: 'none', background: '#0b1e2e' }}
                title="input-form-renderer"
            />
        </Box>
    );
}
